import { useAvivaDispatch } from "@redux/hook";
import { updateToIntialState1 } from "@redux/slices/CCP/step1Slice";
import { updateToIntialState2 } from "@redux/slices/CCP/step2Slice";
import { updateToIntialState3 } from "@redux/slices/CCP/step3Slice";
import { updateToIntialState4 } from "@redux/slices/CCP/step4Slice";
import { updateToIntialState6 } from "@redux/slices/CCP/step6Slice";

export default function useReduxReset() {
  const dispatch = useAvivaDispatch();

  return () => {
    dispatch(updateToIntialState1(""));
    dispatch(updateToIntialState2(""));
    dispatch(updateToIntialState3(""));
    dispatch(updateToIntialState4(""));
    dispatch(updateToIntialState6(""));
  };
}
